/**
 * Mlyn Wishlist System
 * Using localStorage to save wishlist items
 */

document.addEventListener('alpine:init', () => {
  Alpine.store('xWishlist', {
    items: [],
    
    init() {
      this.loadFromStorage();
    },
    
    // Load wishlist from localStorage
    loadFromStorage() {
      try {
        const saved = localStorage.getItem('mlyn_wishlist');
        if (saved) {
          this.items = JSON.parse(saved);
        }
      } catch (e) {
        console.error('Error loading wishlist:', e);
        this.items = [];
      }
    },
    
    // Save wishlist to localStorage
    saveToStorage() {
      try {
        localStorage.setItem('mlyn_wishlist', JSON.stringify(this.items));
      } catch (e) {
        console.error('Error saving wishlist:', e);
      }
    },
    
    // Toggle product in wishlist
    toggle(productId) {
      const index = this.items.indexOf(productId);
      if (index > -1) {
        // Remove from wishlist
        this.items.splice(index, 1);
      } else {
        // Add to wishlist
        this.items.push(productId);
      }
      this.saveToStorage();
    },
    
    // Check if product is in wishlist
    has(productId) {
      return this.items.includes(productId);
    },
    
    // Get wishlist count
    get count() {
      return this.items.length;
    },
    
    // Clear all wishlist items
    clear() {
      this.items = [];
      this.saveToStorage();
    }
  });
});
